import { render, staticRenderFns } from "./UserSettingsNuvolos.vue?vue&type=template&id=b8ea3a20&"
import script from "./UserSettingsNuvolos.vue?vue&type=script&lang=js&"
export * from "./UserSettingsNuvolos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports